<div [class.tooltip]="isTooltipStyle" data-test="highlight-container" class="highlight-container sg-flex-column">
  <button data-test="highlight-exit-button" (click)="close()" mat-icon-button class="close-button"><mat-icon>close</mat-icon></button>
  @if (imageSrc && imagePosition === 'top') {
  <div class="image-container image-top" [style.background-image]="'url('+imageSrc+')'"></div>
  }
  <div [ngClass]="{ 'top': imagePosition === 'bottom', 'bottom': imagePosition === 'top' }" class="content-container sg-flex-column">
    <div class="announcement-type" [ngClass]="announcementType">{{ announcmentKeyToLabel[announcementType] }}</div>
    @if (title) {
    <div class="title" data-test="highlight-title" [innerHtml]="title"></div>
    }
    <div class="message" data-test="highlight-message">{{message}}</div>
    <div class="button" data-test="highlight-confirm-button">
      @if (hideConfirmButton | sgNegate) {
      <button (click)="close()" mat-stroked-button>GOT IT</button>
      }
    </div>
  </div>
  @if (imageSrc && imagePosition === 'bottom') {
  <div class="image-container image-bottm" [style.background-image]="'url('+imageSrc+')'"></div>
  }
</div>
